import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SearchUsersParameters, UserView } from '@api-proxies';
import { UserService } from '@http/clients/user.service';
import { UserRoles } from '@models/enums/UserRoles';
import { EditorComponentBase, GenericTypeAheadDropdownComponent } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../custom-menu-item/custom-menu-item.component';

@Component({
    selector: 'app-user-editor',
    templateUrl: './user-editor.component.html',
    styleUrls: ['./user-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadDropdownComponent, CustomMenuItemComponent]
})
export class UserEditorComponent extends EditorComponentBase<number | undefined> implements OnInit {
    selectedUser?: UserView;

    usersSearchResult?: UserView[];

    usersSearchText: string;

    userRoleIds: UserRoles[];

    constructor(private readonly userService: UserService) {
        super();
        this.userRoleIds = [UserRoles.SalesPerson];
        this.usersSearchText = '';
    }

    async ngOnInit(): Promise<void> {
        this.userRoleIds = this.additionalInfo?.roles ?? [UserRoles.SalesPerson];
        if (this.bindingProperty) {
            this.selectedUser = await this.userService.getById(this.bindingProperty);
        }
    }

    async onUsersTextChanged(): Promise<void> {
        if (!this.usersSearchText) return;

        this.usersSearchResult = await this.userService.search({
            filterText: this.usersSearchText,
            roleIds: this.userRoleIds
        } as SearchUsersParameters);
    }

    onSelectedUser() {
        this.bindingProperty = this.selectedUser?.id;
        this.valueChange.emit();
    }
}
